import { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';

import GlobalLoader from '~/shared/components/GlobalLoader';
import pages from './pages';
import PageRedirect from './pages/PageRedirect';

export default () => (
  <Suspense fallback={<GlobalLoader show />}>
    <Switch>
      {pages.map(page => (
        <Route key={page.path} path={page.path} exact={page.exact} component={page.component} />
      ))}
      <Route path="*" render={({ location }) => <PageRedirect location={location} />} />
    </Switch>
  </Suspense>
);
